export const formatCustomDate = date => {
  if (!date) return 'N/A';
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return 'N/A';
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };
  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(parsedDate);
  const getPart = type => parts.find(p => p.type === type)?.value || '';
  return `${getPart('day')}-${getPart('month')}-${getPart('year')}, ${getPart('hour')}:${getPart('minute')}:${getPart('second')} ${getPart('dayPeriod')}`;
};

export const formatDate = date => {
  if (!date) return 'N/A';
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return 'N/A';
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };
  return parsedDate.toLocaleDateString('en-IN', options);
};

export function formatProjectName(name) {
  return name?.toUpperCase().replace(/[_-]/g, ' ');
}

export const handleResponse = response => {
  const { data } = response;
  if (data && data.status === 'success') {
    return data;
  }
  throw new Error(data.message || 'An error occurred');
};

export const handleError = error => {
  if (process.env.NODE_ENV === 'development') {
    console.error('API Error:', error);
  }
  return Promise.reject(error.response?.data || { message: 'Unknown error occurred' });
};

export const stripOrderFields = obj => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) {
    return obj.map(stripOrderFields);
  }
  const result = {};
  const orderings = {};
  for (const key in obj) {
    if (key === '_order') continue;
    const value = obj[key];
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (value._order && Array.isArray(value._order)) {
        orderings[key] = value._order;
      }
      result[key] = stripOrderFields(value);
    } else if (Array.isArray(value)) {
      result[key] = value.map(stripOrderFields);
    } else {
      result[key] = value;
    }
  }
  if (Object.keys(orderings).length) {
    Object.defineProperty(result, '__orderings', {
      value: orderings,
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }
  return result;
};

export const getSortedKeys = (obj, parentKey) => {
  if (!obj || typeof obj !== 'object') return [];

  const targetObj = parentKey && obj[parentKey] ? obj[parentKey] : obj;
  const allKeys = Object.keys(targetObj);
  const orderings = obj.__orderings;
  if (orderings && parentKey && orderings[parentKey]) {
    const orderedKeys = orderings[parentKey].filter(key => key in targetObj);
    const remainingKeys = allKeys.filter(key => !orderedKeys.includes(key));
    return [...orderedKeys, ...remainingKeys];
  }
  if (targetObj._order && Array.isArray(targetObj._order)) {
    const orderedKeys = targetObj._order.filter(key => key in targetObj);
    const remainingKeys = allKeys.filter(key => !orderedKeys.includes(key));
    return [...orderedKeys, ...remainingKeys];
  }
  return allKeys;
};

export const isValidUnit = unit => {
  return unit && unit !== '#' && unit.trim() !== '';
};

export const toTitleCase = str => {
  return str ? str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) : '';
};

export const getStatusVariant = status => {
  if (!status) return 'info';
  const s = status.toLowerCase();
  if (s === 'completed') return 'success';
  if (s === 'in_progress') return 'info';
  if (s === 'created') return 'warning';
  if (s === 'draft') return 'secondary';
  return 'info';
};
